import React from 'react';
import { Select, Typography } from 'antd';
import { MUTATION_REASON_OPTIONS } from './types';

const { Text } = Typography;

type Props = {
  value: string | null;
  onChange: (v: string) => void;
  disabled?: boolean;
};

export function MutationReasonField({ value, onChange, disabled }: Props) {
  return (
    <div className="mutation-workspace__reason">
      <Text strong>
        Причина изменения <Text type="danger">*</Text>
      </Text>
      <Select
        style={{ width: '100%', marginTop: 8 }}
        placeholder="Выберите причину"
        value={value ?? undefined}
        onChange={onChange}
        disabled={disabled}
        options={MUTATION_REASON_OPTIONS.map((o) => ({ value: o.value, label: o.label }))}
      />
    </div>
  );
}
